import React from 'react';
import { motion } from 'framer-motion';
import { GlassPanel } from '../components/common/GlassPanel';

const ExperienceImpl = ({ accent, mood }) => (
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen pt-32 pb-48 px-4 sm:px-4 sm:px-8 lg:px-24">
    <h2 className="text-5xl font-black italic text-white mb-16 uppercase tracking-tighter">EXPERIENCE</h2>

    <div className="space-y-10 max-w-3xl">
      <GlassPanel mood={mood} className="p-10 rounded-3xl">
        <h3 className="text-2xl font-black text-white mb-2">Full Stack Developer</h3>
        <p className="mb-4 font-black uppercase text-xs tracking-widest" style={{ color: accent.color }}>Personal Projects • 2023 – Present</p>
        <p className="text-white/60 leading-relaxed">
          Built multiple MERN applications, dashboards, and APIs.
          Focused on clean UI, authentication systems, REST APIs and deployment.
        </p>
      </GlassPanel>
    </div>
  </motion.div>
);

export const Experience = React.memo(ExperienceImpl);
